import N8nPromptInputSuggestions from './N8nPromptInputSuggestions.vue';

export default N8nPromptInputSuggestions;
export type { WorkflowSuggestion } from '../../types/assistant';
